import React, { useEffect, useState } from "react";
import moment from "moment";
import "moment/locale/ko";

import { NotifListContainer } from "../styled/dashboard";
import { CustomInput } from "../../../../../common/styled/common";
import NotData from "./notData";

const NotifyList = ({
  notification,
  readNotification,
  toggleNotiSelection,
  selectedNotiNos,
  isDelete,
  openResponse,
}) => {
  const NoticeItem = ({ item }) => {
    const [isInvite, setIsInvite] = useState(false);

    const notiType = {
      S: "일정",
      C: "커스텀알림",
      I: "초대",
      R: "가입",
      A: "광고",
      RA: "가입신청",
      F: "피드",
      OU: "고객알림",
      OC: "사장님 알림",
      OCC: "주문취소",
      ORC: "주문취소요청",
    };

    const clickNotify = (item) => {
      if (isDelete) return;
      if (["I", "ORC"].includes(item.notiType)) {
        setIsInvite(!isInvite);
      } else {
        readNotification(item);
      }
    };

    return (
      <li
        className={`${item.readYn === "Y" ? "read" : "unread"}${isDelete ? " delete" : ""}`}
        onClick={() => clickNotify(item)}>
        <img src={item.imgPath ? imgHandler(item.imgPath) : "/img/application_price_1.png"} />
        <div className="cont">
          <span>{notiType[item.notiType]}</span>
          <div className="info">
            <strong>{item.title}</strong>
            <span className="date">{moment(item.createDt).format("YYYY-MM-DD LT")}</span>
          </div>
          <p>{item.content}</p>
        </div>
        {isDelete && (
          <CustomInput>
            <input
              type="checkbox"
              name={item.notiNo}
              onChange={(e) => {
                e.stopPropagation();
                toggleNotiSelection(item.notiNo);
              }}
              checked={selectedNotiNos.includes(item.notiNo)}
            />
            <span className="checkmark"></span>
          </CustomInput>
        )}
        {["I", "ORC"].includes(item.notiType) && (
          <div className={`actions ${isInvite ? "active" : "inactive"}`}>
            {["수락", "거절"].map((label, idx) => (
              <button key={label} onClick={() => openResponse(item, idx === 0)}>
                {label}
              </button>
            ))}
          </div>
        )}
      </li>
    );
  };

  return (
    <NotifListContainer>
      {notification.length > 0 ? (
        <ul>
          {notification?.map((item) => (
            <NoticeItem item={item} />
          ))}
        </ul>
      ) : (
        <NotData message="새로운 알림이 존재하지 않습니다." />
      )}
    </NotifListContainer>
  );
};

export default NotifyList;
